import {cn} from '@sollapay/ui';
import {Fragment} from 'react';

import {TrustAccountStatusSection} from './TrustAccountStatusSection';

import type {TrustAccountGroupFold, TrustStatusGroup} from '../utils';
import type {ReactNode} from 'react';

export interface TrustAccountStatusSectionsProps<Item extends {id: string}> {
  groups: TrustStatusGroup<Item>[];
  groupFold: TrustAccountGroupFold;
  renderItem: (item: Item) => ReactNode;
  className?: string;
}

/** The card view's status groups (from `groupByTrustStatus`): one foldable section of cards per status. */
export function TrustAccountStatusSections<Item extends {id: string}>({
  groups,
  groupFold,
  renderItem,
  className
}: TrustAccountStatusSectionsProps<Item>) {
  return (
    <div data-slot="trust-account-status-sections" className={cn('flex flex-col gap-7', className)}>
      {groups.map(({status, items}) => (
        <TrustAccountStatusSection
          key={status}
          status={status}
          count={items.length}
          isCollapsed={groupFold.isCollapsed(status)}
          onToggle={() => groupFold.toggle(status)}
        >
          {items.map(item => (
            <Fragment key={item.id}>{renderItem(item)}</Fragment>
          ))}
        </TrustAccountStatusSection>
      ))}
    </div>
  );
}
